import React, { useState } from "react";

interface FileThumbnailProps {
  /** サムネイル取得 URL (/api/files/thumbnail/{fileId}?honbuId=..&roomId=..) */
  src: string;
  /** 表示サイズ (px、正方形) */
  size?: number;
  /** 取得失敗・非対応 (204) 時に表示するアイコン */
  fallback: React.ReactNode;
}

/**
 * ファイルサムネイル表示 (F014)。
 * 画像の取得に失敗した場合 (非対応形式の 204 応答を含む) は従来のアイコン表示にフォールバックする。
 */
export const FileThumbnail: React.FC<FileThumbnailProps> = ({
  src,
  size = 40,
  fallback,
}) => {
  const [failed, setFailed] = useState(false);

  if (failed) return <>{fallback}</>;

  return (
    <img
      src={src}
      alt=""
      loading="lazy"
      onError={() => setFailed(true)}
      style={{
        width: size,
        height: size,
        objectFit: "cover",
        borderRadius: 6,
        flexShrink: 0,
        display: "block",
        backgroundColor: "rgba(128,128,128,0.08)",
      }}
    />
  );
};
